const data = {
  id: 1,
  title: 'Listen and choose the word with the different beginning sound.',
  subTitle: 'Nghe và chọn từ có âm đầu tiên khác với các từ còn lại.',
  question: '',
  answers: [
    { id: 1, answer: '', isCorrect: false, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/50a609ec-afad-4859-8456-a469f3fbe8ee.mp3' },
    { id: 2, answer: '', isCorrect: false, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/9d27a31a-fd1a-46ce-b03d-68bd09d3b31b.mp3' },
    { id: 3, answer: '', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/157fb1bd-47bf-478e-af9d-11913aa10689.mp3' },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};

export default data;
